import React, {Component} from 'react';
import {Link} from "react-router"
import {prefixLink} from "gatsby-helpers"
import {config} from "config"

export default class Template extends Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./_template.jsx